import { Grid } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { isDiferentiatedBrands } from '../../../../themes/themes';
import { getBrandStorage } from '../../../../utils/getBrand';

const brand = getBrandStorage();

// Card de Exclusivo (Resultado da Busca) — espelha o Figma:
// imagem a esquerda (altura cheia), conteudo a direita em coluna com
// preco + botao no rodape (depois de um divisor), alinhados a base da imagem.
export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-top: 16px;
    display: flex;
    gap: 16px;
    padding: 17px;
    background-color: ${isDiferentiatedBrands(brand)
      ? theme.palette.secondary.white
      : '#FFF'};
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0px 1px 4px #15223214;
    font-family: 'Poppins';

    ${theme.breakpoints.down('xs')} {
      flex-direction: column;
    }
  `}
`;

export const CardContent = styled(Grid)`
  display: contents;
`;

export const ExperienceDetails = styled(Grid)`
  ${({ theme }) => css`
    display: contents;

    .carousel-container {
      flex: none;
      align-self: stretch;
      width: 240px;
      height: 224px;
      border-radius: 8px;
      overflow: hidden;

      /* forca altura fixa 224px em toda a cadeia do carousel e remove o raio
         da imagem — o overflow:hidden + border-radius 8 do container arredonda
         as 4 bordas. Sobrepoe height:200px / top-left-radius do CarouselComponent. */
      > div,
      .carousel,
      .carousel .slider-wrapper,
      .carousel .slider-wrapper.axis-horizontal,
      .carousel .slider,
      .carousel .slide,
      .carousel .slide > div,
      .card {
        height: 224px !important;
      }
      .image,
      .image.card,
      img {
        height: 224px !important;
        width: 100%;
        object-fit: cover !important;
        border-radius: 0 !important;
      }

      ${theme.breakpoints.down('xs')} {
        width: 100%;
      }
    }

    .content {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      padding: 4px 0;

      .experience-details {
        display: flex;
        width: 100%;

        .experience-name {
          font-size: 18px;
          font-weight: 700;
          color: #1e293b;
        }
      }

      .location {
        font-size: 12px;
        color: #64748b;
        margin-top: 2px;
      }

      .short-description {
        flex-shrink: 0;
        font-size: 14px;
        color: #475569;
        margin: 8px 0;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .included-bullets {
        margin: 6px 0 10px;
        padding-left: 18px;
        font-size: 12px;
        color: #64748b;

        li {
          margin-bottom: 2px;
        }
      }
    }
  `}
`;

// rodape do card: empurrado para a base da coluna de conteudo (margin-top:auto),
// divisor no topo, preco a esquerda e botao Detalhes a direita.
export const BottomDetails = styled(Grid)`
  ${({ theme }) => css`
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid #f1f5f9;

    div {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;

      .button-select {
        margin-left: auto;
        border-radius: 8px;
        height: 36px;
        width: 108px;
      }

      .old-value {
        color: #94a3b8;
        font-size: 12px;
        /* risca o "De X pts por" inteiro (Figma) */
        text-decoration: line-through;

        .value {
          text-decoration: line-through;
        }
      }

      .final-value {
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
        margin-left: 4px;
      }

      .discount {
        background-color: #fff0d1;
        margin-left: 10px;
        margin-right: 15px;
        border-radius: 2px;
        font-weight: 700;
        font-size: 10px;
        color: #e7a413;
        padding: 2px;
      }
    }
  `}
`;
